import auth from './auth';
import master from './master';
import general from './general';
import pegawai from './pegawai';
import pengguna from './pengguna';
import upload from './upload';
import penerimaan from './penerimaan';

export default {
	auth,
	master,
    general,
	pegawai,
	pengguna,
	upload,
	penerimaan,
};
